<template>
    <div class="item-text item-name text-uppercase">
        {{ title }}
        <br v-if="watchedSize || wishlistSize" />
        <span v-if="watchedSize">({{ __('frontend_js.watchdogs.size') }}: {{ watchedSize }})</span>
        <span v-if="wishlistSize" v-html="`(${__('frontend_js.wishlist.size')}: ${wishlistSize})`"></span>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        score: {
            type: Number,
            required: true,
        },
        watchedSize: {
            default: false,
        },
        wishlistSize: {
            default: false,
        },
    },
};
</script>
